import React from "react";
import { Button } from "react-bootstrap";
import { SOCKET_CONNECTION, TOAST_DISMISS, TOAST_ERROR, TOAST_SUCCESS, getWallId } from "../../../../../../utils";
import { getAppsMOreDetails, updateTheme } from "../../../../../../actions/appsMoreAction";
import { connect } from "react-redux";
import withRouter from "../../../../../CommonComponents/WithRouter";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";

const getLayoutText = (layoutType, themeId) => {
    let content = '';
    let subContent = '';
    if (layoutType == 'Grid') {
        content = 'Pixel perfection, grid edition \n Best for websites and displays!';
        subContent = 'Grid: Where social media gets organized, ready to captivate any audience.';
        if (themeId == 66) {
            subContent = 'A sleek showcase presenting content in concise squares. Featuring post summaries, handles, and hashtags. ';
        } else if (themeId == 67) {
            subContent = `In Pixel, our Grid theme dazzles with square-cut posts- No captions, no handles. It's a dynamic flip of visuals. `;
        } else if (themeId == 68) {
            subContent = `One post steps into the spotlight, changing size like characters as captions, handles, and the source emerge theatrically. `;
        } else if (themeId == 69) {
            subContent = `Columns of reel-sized ascend, devoid of captions and handles- Showing only the source, keeping it authentic.`;
        }
        return { content, subContent };
    } else if (layoutType == 'Carousel') {
        content = 'Level up your website- Captivate website viewers with social story carousels.';
        subContent = 'Showcase your best social moments on your website, one captivating visual at a time!';
        if (themeId == 70) {
            subContent = 'Tailored for websites especially, showcasing content in sets, merging style with substance. ';
        } else if (themeId == 71) {
            subContent = `A chic choice square-cut post presentation. Watch your content gracefully transform, an ever-engaging spectacle! `;
        } else if (themeId == 73) {
            subContent = `An enchanting display of reels takes center stage, creating a transition that gives an unforgettable experience. `;
        }
        return { content, subContent };
    }else if (layoutType == 'Slideshow') {
        content = 'Where each slide tells a tale on digital displays!';
        subContent = 'Spotlight your social feed on the big screen, making a lasting event impression.';
        if (themeId == 74) {
            subContent = 'On the center stage, a post shines, while a faded twin adds elegance in the background- With captions, handles, and hashtags displayed. ';
        } else if (themeId == 76) {
            subContent = `Classic Slideshow—where one post reigns supreme on your chosen backdrop. On stage, captions, handles, and the source! `;
        } else if (themeId == 77) {
            subContent = `On a display screen, posts gracefully move, creating a storytelling canvas with captions, handles, and the source on the right stage. `;
        }
        return { content, subContent };
    } else {
        content = 'Flowing tales, a visual cascade! \n Fit for websites and displays';
        subContent = 'Turn your social feed into an engaging waterfall, captivating audiences online and offline!';
        if (themeId == 62) {
            subContent = 'A sleek showcase presenting content in concise squares. Featuring post summaries, handles, and hashtags. ';
        } else if (themeId == 63) {
            subContent = `Posts gracefully descending with rounded edges, revealing only the user handle. It's a attractive display of simplicity. `;
        } else if (themeId == 64) {
            subContent = `One post steps into the spotlight, changing size like characters as captions, handles, and the source emerge theatrically. `;
        } else if (themeId == 65) {
            subContent = `Columns of reel-sized ascend, devoid of captions and handles- Showing only the source, keeping it authentic. `;
        }
        return { content, subContent };
    }
}
class SelectTheme extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            setIsLoading: false,
            themeData: [],
            themChange: false
        }
    }

    onThemeChange = (params, themeId, layoutId) => {

        const { themecardStyle, themeUpdateData } = this.props;

        if (params.id == themeId) {
            this.setState({ themeData: params })
        } else {
            themecardStyle({ themeId: params.id }, 'theme');
            themeUpdateData(layoutId, params.name);
            this.setState({ themeData: params, themChange: true })
        }
    }


    onThemeApply = () => {

        const { themeData } = this.state;
        const { wallData } = this.props;


        this.setState({ setIsLoading: true });
        const formData = new FormData();

        const Personalization = wallData.wall.Personalization;
        const personalizationId = Personalization.id;

        formData.append('themeType', themeData.themeType);
        formData.append('theme', themeData.id);
        formData.append('textDecorateStatus', Personalization.textDecorateStatus);
        formData.append('postFeaturedStatus', Personalization.postFeaturedStatus);
        formData.append('filterEnableStatus', Personalization.filterEnableStatus);
        formData.append('textDecorate', Personalization.textDecorate);
        formData.append('postFeatured', Personalization.postFeatured);
        formData.append('filterStatus', Personalization.filterStatus);
        formData.append('trimcontent', Personalization.trimcontent);
        formData.append('trimContentStatus', Personalization.trimContentStatus);
        formData.append('popupSlideShow', Personalization.popupSlideShow);
        formData.append('popupSlideShowStatus', Personalization.popupSlideShowStatus);
        formData.append('themeTypePre', Personalization.autoScroll);
        formData.append('padding', Personalization.padding);
        formData.append('ownerId', localStorage.getItem('ownerId'));

        const wallId = wallData.wallId;

        updateTheme(wallId, personalizationId, Object.fromEntries(formData)).then((response) => {

            const { responseCode, responseStatus, responseData } = response.data;

            if (responseCode == 200) {
                TOAST_DISMISS();

                if (responseStatus == 'success') {
                    SOCKET_CONNECTION.emit('wallsuperrefresh', { 'wallId': wallId, sync: responseData[0]?.id });
                    setTimeout(() => {
                        this.props.getAppsMOreDetails();
                        this.props.activeSetting(0,0,responseData[0]?.themeRuleId);
                        TOAST_SUCCESS("Theme Applied Successfully.")
                    }, 200);
                } else {
                    TOAST_ERROR('Error');
                }
                this.setState({ setIsLoading: false })
            }

        }).catch((error) => {
            TOAST_ERROR(error.message);
            this.setState({ setIsLoading: false })
        })
    }

    applyChanges = (status) => {
        const { showDiscardPop } = this.props;
        showDiscardPop(this.onThemeApply, 'layout', status);
    }

    render() {

        const { activeLayout, wallData, layoutError } = this.props;
        const { setIsLoading, themChange } = this.state;
        
        const themeId = wallData.wall.Personalization.ThemeRule.themeId

        const layoutText = getLayoutText(activeLayout.layout, themeId);
        return (
            <div className="px-3 pt-5">
                <div className="select-layout mb-4">
                    <div className="pb-3">
                        <label className="card-label font-weight-bolder text-dark">Select Theme : {activeLayout?.layout} </label>
                    </div>

                    {activeLayout && activeLayout.theme.map((param,key) => {
                        return (<div key={key} className={`template_aside_inner mb-3 ${param.id == '88' ? localStorage.getItem('ownerId')=='179921' ? "":"d-none" :""}`}>
                            <div onClick={() => this.onThemeChange(param, themeId, activeLayout.index)} className="flex-column w-100 btn-group" key={param.id}>
                                <label className={`${param.id == themeId ? `bg-white btn btn-outline-dark bg-transparent active active-disable` : `btn btn-secondary`} py-2 px-2`}>
                                    <div className="d-flex align-items-center position-relative">
                                        <div className="overflow-hidden">
                                            <p className="mb-0 text-dark text-ellipsis text-start">{param.name}</p>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>)
                    })}

                    <div className="save-settings d-flex align-items-center justify-content-between mt-8">
                        <Button onClick={() => this.applyChanges(0)} variant="secondary" className="position-relative w-50 me-1">
                            <span className="position-relative">Back</span>
                        </Button>
                        <Button disabled={setIsLoading || layoutError || !themChange ? true : false} onClick={() => this.applyChanges(1)} variant="dark" className={`w-50 me-1 ${setIsLoading ? `spinner spinner-white spinner-right disabled` : layoutError ? `` : null}`}>Save</Button>
                    </div>
                </div>

                <div className="layout-disc text-center pt-8">
                   <strong className="text-uppercase">{activeLayout?.layout}</strong>
                   <p>{layoutText.content}</p><hr /><p>{layoutText.subContent}</p>
                </div>

                <div className="layout-disc-icons pt-8">
                    <ul className="d-flex align-items-start justify-content-center flex-wrap">
                        <li>
                            <FontAwesomeIcon type={'light'} icon={'tv-retro'} iconClass={'fs-2'} />
                            <p className="mb-0 mt-2">TV Screen</p>
                        </li> 
                         {
                            activeLayout && activeLayout.layout!='Slideshow' ?
                                <li>
                                    <FontAwesomeIcon type={'light'} icon={'rectangle-code'} iconClass={'fs-2'} />
                                    <p className="mb-0 mt-2">Website</p>
                                </li> : <></>
                        }
                        <li>
                        <i class="fa-solid fa-sign-posts"></i>
                            <FontAwesomeIcon type={'light'} icon={'projector'} iconClass={'fs-2'} />
                            <p className="mb-0 mt-2">Projector</p>
                        </li>
                        <li>
                            <FontAwesomeIcon type={'light'} icon={'presentation-screen'} iconClass={'fs-2'} />
                            <p className="mb-0 mt-2">Digital Signage</p>
                        </li>
                    </ul>
                </div>
            </div>

        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getAppsMOreDetails: () => dispatch(getAppsMOreDetails(getWallId())),
    }
}

export default withRouter(connect(null, mapDispatchToProps)(SelectTheme));
